import { FC } from 'react';
import { cva } from 'class-variance-authority';
import ContestPreview from '@/widgets/ContestPreview/ContestPreview';
import Container from '@/shared/ui/Container/ui/Container';
import { IContestDetail } from '@/shared/api/contest/getContests/types';
import { useContestsIntersectionsObserver } from '@/widgets/Contests/hooks/useContestsIntersectionsObserver';

interface Props {
  contests: IContestDetail[];
  isLoading?: boolean;
  scrollMarginTop?: number;
  onContestViewportEnter?: (contest: IContestDetail) => void;
}

const Contests: FC<Props> = ({
  contests,
  isLoading,
  scrollMarginTop = 0,
  onContestViewportEnter,
}) => {
  const contestRefs = useContestsIntersectionsObserver({
    contests,
    rootMarginTop: -scrollMarginTop,
    onContestViewportEnter,
  });

  /* TODO: ждём макета или нарисуем сами? */
  if (isLoading) {
    return <></>;
  }

  /* TODO: ждём макета или нарисуем сами? */
  if (!contests?.length) {
    return <></>;
  }

  return (
    <Container className={cvaContainer()} size={'lg'}>
      {contests.map((el, index) => (
        <ContestPreview
          key={el.id}
          id={String(el.id)}
          ref={(instance) => (contestRefs.current[index] = instance)}
          item={el}
          style={{ scrollMarginTop: `${scrollMarginTop}px` }}
        />
      ))}
    </Container>
  );
};

const cvaContainer = cva([
  'Contests-cvaContainer',
  'flex flex-col gap-7.2 md-max:gap-4',
]);

export default Contests;
